import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Star, Tag, HelpCircle, User } from "lucide-react";
import logo from "../../assets/logo.png";
import { getAccessToken } from "../utils/authTokenStore"; 

export default function Navbar() {
  const location = useLocation();
  const isLoggedIn = !!getAccessToken();

  const navItems = [
    { path: "/features", icon: <Star size={17} />, label: "Features" },
    { path: "/pricing", icon: <Tag size={17} />, label: "Pricing" },
    { path: "/", icon: <Home size={17} />, label: "Home", center: true },
    { path: "/support", icon: <HelpCircle size={17} />, label: "Support" },
    { path: "/profile", icon: <User size={17} />, label: "Profile" },
  ];
  const navItems2 = [
    { path: "/features", icon: <Star size={20} />, label: "Features" },
    { path: "/pricing", icon: <Tag size={20} />, label: "Pricing" },
    { path: "/", icon: <Home size={20} />, label: "Home", center: true },
    { path: "/support", icon: <HelpCircle size={20} />, label: "Support" },
    { path: "/profile", icon: <User size={20}/>, label: "Profile" },
  ];

  return (
    <>
      {/* Desktop Nav */}
      <nav className="hidden md:flex justify-between items-center px-6 py-4 bg-[#172112]   border-b border-white text-white">
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="FitTrack Logo" className="w-5 h-5 mr-1" />
          <h1 className="text-xl font-bold">FitTrack</h1>
        </Link>

        <ul className="flex gap-6 items-center text-base">
          {navItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`flex items-center gap-1 hover:text-[#54D12B] transition-colors ${
                  location.pathname === item.path ? "text-green-400" : ""
                }`}
              >
                {item.icon}
                {item.label}
              </Link>
            </li>
          ))}
          {!isLoggedIn && ( 
            <li>
              <Link to="/signup">
                <button className="bg-[#54D12B] hover:bg-[#43b51f] rounded-3xl px-4 py-[7px] rounded text-black font-semibold transition-all duration-300 hover:shadow-lg">
                  Get Started
                </button>
              </Link>
            </li>
          )}
        </ul>
      </nav>

      {/* Mobile Bottom Nav */}
      <nav className="md:hidden fixed border-t border-white bottom-0 left-0 right-0 bg-[#111e13] text-white flex justify-around items-center py-3 z-50 shadow-inner">
        {navItems2.map((item) => {
          const isActive = location.pathname === item.path;
          const isHome = item.center;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center transition-all duration-200 ${
                isHome
                  ? `w-16 h-16 -mt-6 rounded-full bg-white text-black border-4 ${
                      isActive ? "border-green-500" : "border-gray-500"
                    }`
                  : `w-10 h-10 rounded-full p-2 ${
                      isActive
                        ? "bg-green-500 text-black"
                        : "bg-[#1a2b1f] text-gray-400"
                    }`
              }`}
            >
              {item.icon}
            </Link>
          );
        })}
      </nav>
    </>
  );
}
